import React from 'react';

import {
    DeliveryTag,
    ForSaleFavorite,
    ForSalePrice,
    H2,
    LocationAtBottomWrapper,
    VatStyle,
} from './listing-tile.style';
import { InfoWrapper } from './info-wrapper/info-wrapper';
import { TileHeaderWrapper } from './title-row-wrapper/title-row-wrapper';

export interface Props {
    title: string;
    favouriteToggle: React.ReactElement | undefined;
    location: string;
    price: string;
    vat?: string;
    supportShipping?: boolean;
}

const TileInfoMobileForSale = ({
    title,
    favouriteToggle,
    location,
    price,
    vat,
    supportShipping,
}: Props) => {
    const isGridViewOnDesktop = true;
    return (
        <>
            <TileHeaderWrapper isForSaleMobile>
                <ForSalePrice data-testid="price">
                    {price}
                    {vat && <span css={VatStyle}> ({vat})</span>}
                </ForSalePrice>
                <ForSaleFavorite>{favouriteToggle}</ForSaleFavorite>
            </TileHeaderWrapper>
            <H2 isGridView={isGridViewOnDesktop} isForSaleCategory>
                {title}
            </H2>
            <InfoWrapper>
                <LocationAtBottomWrapper>{location}</LocationAtBottomWrapper>
            </InfoWrapper>
            {supportShipping && <DeliveryTag style={{ marginTop: 2 }}>Delivery available</DeliveryTag>}
        </>
    );
};

export default TileInfoMobileForSale;
